import React, { useState } from 'react';
// eslint-disable-next-line no-unused-vars
import ModelCheck from '../model/ModelCheck';
import { downloadImagesAsZip } from '../util/zipImages';
import { IconDownload, IconLoading } from '../util/Icons';

const Gallery =  (props) => {
    const isMobile = window.innerWidth < 768
    /** @type {ModelCheck} */
    const check = props.data

    const [selected, setSelected] = useState(0)
    const [loadingStates, setLoadingStates] = useState(Array(check.photos.length).fill(true)); // Assuming 3 images initially loading


    function downloadAll() {
        let lista = []
        for (var i = 0; i < check.photos.length; i++) {
            const photo = check.photos[i]
            lista.push(photo.file)
        }
        downloadImagesAsZip(lista)
    }

    const handleImageLoad = (index) => {
        // Set the loading state to false when the image is loaded
        setLoadingStates((prevStates) => {
          const newState = [...prevStates];
          newState[index] = false;
          return newState;
        });
    };

    const LoadingImg = () => { 
        return (
            <div className='icon-loading'>
                <IconLoading color='white' size={30}/>
            </div>
        )
    }


    return (
        <div className='gallery-container'>

            <div className='gallery-big-img'> 
                {
                    <img src={check.photos[selected].file} alt="" onLoad={() => handleImageLoad(0)}/>               
                }

                <div className='icon-download-all' onClick={downloadAll}>
                    <IconDownload/> 
                </div>

            </div>

            <div className='gallery-grid'>
                {
                    check.photos.map((p, index) => {
                        return <div key={index} >
                        
                            <img 
                                src={p.file} 
                                alt={`Loadings ${index + 1}`} 
                                key={index} 
                                onLoad={() => handleImageLoad(index)}
                                onClick={() => {setSelected(index)}}
                            />
                        </div>
                    })
                }
            </div>
        </div>
    )
}

export default Gallery